import appStore from 'store';
import api from './api';
import { STATUS_TYPE, DEPOSIT_STATUS_TYPE, DEPOSIT_STATUS } from './constants';

const store = {
    namespaced: true,
    state: {
        auditList: [],
        activeTab: 'all',
        allCoins: [],
        chooseCoinType: '',
        userRecords: [],
        audistCount: 0,
        userDetailTotal: 0,
        userWallet: [],
        pagination: { page: 1, size: 10 },
    },
    mutations: {
        
        setAuditList(state, payload) {
            state.auditList = payload.slice().map(item => {
                return {
                    ...item,
                    __status: STATUS_TYPE[item.txStatus],
                    __depositStatus: DEPOSIT_STATUS[item.txDepositStatus || 0]
                };
            });
        },
        changeTab(state, payload) {
            state.activeTab = payload;
        },
        setChooseTab(state, payload) {
            state.activeTab = payload;
        },
        setBillTypeList(state, payload) {
            state.billTypeList = payload;
        },
        setAllcoins(state, payload) {
            state.allCoins = payload;
        },
        setAudistCount(state, payload) {
            state.audistCount = payload;
        },
        setPagination(state, payload) {
            state.pagination = payload;
        },
        setUserRecords(state, payload) {
            state.userRecords = payload.slice().map(item => {
                return {
                    ...item,
                    __status: item.txType === 1 ?
                        DEPOSIT_STATUS_TYPE[item.txStatus] :
                        STATUS_TYPE[item.txStatus]
                };
            });
        },
        setUserDetailTotal(state, payload) {
            state.userDetailTotal = payload;
        },
        setChooseCoinType(state, payload) {
            state.chooseCoinType = payload;
        },
        setUserWallet(state, payload) {
            state.userWallet = payload;
        }
    },
    actions: {
        
        list({ commit }, query) {
            api.getAuditList(query).then(({ data }) => {
                commit('setAuditList', data.list || []);
                commit('setAudistCount', data.totalCount || 0);
                commit('setPagination', { page: query.page, size: query.size });
            });
        },
        // eslint-disable-next-line
        ensure({ commit }, id) {
            return new Promise(resolve => {
                api.ensureDeposit(id).then(res => {
                    resolve(res);
                });
            });
        },
        // eslint-disable-next-line
        reset({ commit }, id) {
            return new Promise(resolve => {
                api.resetDeposit(id).then(res => {
                    resolve(res);
                });
            });
        },
        abnormal({ commit }, id) {
            return new Promise(resolve => {
                api.setDepositError(id).then(res => {
                    resolve(res);
                });
            });
        },
        cancelTheAudit(context, id) {
            return new Promise(resolve => {
                api.cancelAudit(id).then(res => {
                    resolve(res);
                });
            });
        },
        listBillType({ commit }) {
            api.getBillTypeList().then(({ data }) => {
                commit('setBillTypeList', data);
            });
        },
        getAllCoins({ commit }) {
            api.getAllCoins().then(({ data }) => {
                commit('setAllcoins', data);
            });
        },
        getUserRecords({ commit }, data) {
            api.getUserRecords(data).then(({ data }) => {
                commit('setUserRecords', data.list || []);
                commit('setUserDetailTotal', data.totalCount || 0);
            });
        },
        getUserWallet({ commit }, data) {
            api.getUserWallet(data.userId).then(({ data }) => {
                commit('setUserWallet', data);
            });
        },
        resetUserRecords({ commit }) {
            commit('setUserRecords', []);
            commit('setUserDetailTotal', 0);
            commit('setUserWallet', []);
        },
        changeCoinType({ commit }, data) {
            commit('setChooseCoinType', data);
        },
        changeChooseTab({ commit }, data) {
            commit('setChooseTab', data);
        },
        updateFreeze(context, data) {
            return api.updateFreeze(data);
        },
        cancel(context, data) {
            return api.cancel(data);
        },
        sendWithdrawalTrans(context, data) {
            return api.sendTheWithdrawalTrans(data);
        },
        remark(context, data) {
            return api.remark(data);
        },
        manualConfirm(context, txId) {
            return api.manualConfirm(txId);
        },
        returnToNotApproved(context, txId) {
            return api.returnToNotApproved(txId);
        }
    }
};

appStore.registerModule('depositAudit', store);